import * as React from 'react';
import { twMerge } from 'tailwind-merge'; // Make sure to install this package if not already

interface BadgeProps {
	text: string;
	className?: string;
	borderClassName?: string;
	textClassName?: string;
}

export const Badge: React.FC<BadgeProps> = ({
	text,
	className,
	borderClassName,
	textClassName,
}) => {
	return (
		<div
			className={twMerge(
				'whitespace-nowrap rounded-sm border border-solid border-neutral-800',
				borderClassName,
				className,
			)}
		>
			<div
				className={twMerge(
					'gap-2 self-stretch p-2 text-xs font-bold leading-tight uppercase',
					textClassName,
				)}
			>
				{text}
			</div>
		</div>
	);
};
